import { PERMISSION_CODES } from './permissions.js';
const viewOnly = PERMISSION_CODES.filter((code) => code.endsWith('.view'));
export const DEFAULT_ROLES = [
    {
        code: 'super_admin',
        label: 'Super administrateur technique',
        description: 'Paramètres techniques et gestion globale des accès.',
        portal: 'admin',
        isSystem: true,
        requiresMfa: true,
        defaultScope: 'global',
        permissions: PERMISSION_CODES,
    },
    {
        code: 'admin_fonctionnel',
        label: 'Administrateur fonctionnel',
        description: 'Concours, formulaires et calendriers.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: false,
        defaultScope: 'global',
        permissions: [
            'concours.view',
            'concours.create',
            'concours.update',
            'concours.publish',
            'concours.open',
            'concours.suspend',
            'concours.close',
            'concours.extend',
            'concours.archive',
            'forms.view',
            'forms.create',
            'forms.update',
            'forms.publish',
            'selection.view',
            'selection.configure',
            'centers.manage',
            'payment_methods.view',
            'notifications.templates.manage',
            'reports.view',
        ],
    },
    {
        code: 'responsable_concours',
        label: 'Responsable de concours',
        description: 'Pilotage d’une session de concours.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: false,
        defaultScope: 'competition',
        permissions: [
            'concours.view',
            'concours.update',
            'concours.open',
            'concours.suspend',
            'concours.close',
            'concours.extend',
            'concours.derogation',
            'candidature.view',
            'candidature.assign',
            'candidates.view',
            'selection.view',
            'convocations.generate',
            'convocations.send',
            'notifications.send',
            'corrections.view',
            'reports.view',
            'reports.export',
        ],
    },
    {
        code: 'agent_reception',
        label: 'Agent de réception',
        description: 'Contrôle administratif des dossiers.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: false,
        defaultScope: 'competition',
        permissions: [
            'concours.view',
            'candidates.view',
            'candidature.view',
            'candidature.review',
            'candidature.request_complement',
            'candidature.decide',
            'candidature.correct_after_submit',
            'documents.download',
            'documents.review',
        ],
    },
    {
        code: 'agent_financier',
        label: 'Agent financier',
        description: 'Paiements et rapprochements.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: true,
        defaultScope: 'competition',
        permissions: [
            'concours.view',
            'candidature.view',
            'payment.view',
            'payment.reconcile',
            'payment.manual_entry',
            'payment.refund',
            'payment.export',
            'payment_methods.view',
        ],
    },
    {
        code: 'responsable_commission',
        label: 'Responsable de commission',
        description: 'Affectation des évaluateurs et validation des notes.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: false,
        defaultScope: 'stage',
        permissions: [
            'concours.view',
            'selection.view',
            'evaluators.assign',
            'notes.view',
            'notes.validate',
            'notes.unlock',
            'corrections.view',
            'corrections.approve',
            'pv.generate',
        ],
    },
    {
        code: 'evaluateur',
        label: 'Évaluateur',
        description: 'Saisie et soumission des notes qui lui sont affectées.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: false,
        defaultScope: 'stage',
        permissions: ['notes.view', 'notes.enter', 'notes.submit', 'notes.correct'],
    },
    {
        code: 'responsable_resultats',
        label: 'Responsable des résultats',
        description: 'Contrôle et préparation des classements.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: false,
        defaultScope: 'competition',
        permissions: [
            'concours.view',
            'selection.view',
            'notes.view',
            'results.view',
            'results.calculate',
            'results.rectify',
            'reports.view',
            'reports.export',
        ],
    },
    {
        code: 'autorite_validation',
        label: 'Autorité de validation',
        description: 'Approbation officielle selon délégation.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: true,
        defaultScope: 'competition',
        permissions: [
            'concours.view',
            'candidature.view',
            'candidature.validate',
            'selection.view',
            'selection.rules.validate',
            'results.view',
            'results.approve',
            'results.publish',
            'corrections.view',
            'corrections.approve',
        ],
    },
    {
        code: 'auditeur',
        label: 'Auditeur / contrôleur',
        description: 'Consultation des historiques autorisés, en lecture seule.',
        portal: 'admin',
        isSystem: false,
        requiresMfa: false,
        defaultScope: 'global',
        permissions: [...viewOnly, 'audit.export'],
    },
    {
        code: 'candidat',
        label: 'Candidat',
        description: 'Accès à ses propres informations et candidatures (policies de propriété).',
        portal: 'candidate',
        isSystem: true,
        requiresMfa: false,
        defaultScope: 'global',
        permissions: [],
    },
];
//# sourceMappingURL=roles.js.map